module.exports = __webpack_public_path__ + "img/Union.f3ecb760.svg";